import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {map, finalize, catchError} from 'rxjs/operators';
import {HttpLoader} from '../services/httploader.service';
import {Router} from '@angular/router';
import {NonLoaderHttpHeaderProperty} from '../models/non-loader.model';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private loader: HttpLoader,
    private router: Router,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLoader = !request.headers.get('Non-Loader-Request' as NonLoaderHttpHeaderProperty);
    return next.handle(request).pipe(
      map(event => {
        if (isLoader) {
          this.loader.enabled();
        }
        return event;
      }),
      catchError(error => {
        this.loader.disabled();
        return throwError(error);
      }),
      finalize(() => {
        if (isLoader) {
          this.loader.disabled();
        }
      })
    );
  }
}
